module.exports = __webpack_public_path__ + "fonts/murrayHill_f48752c9972ce4c5e0ec872c9b5d0bc8.ttf";